<input
	type="checkbox"
	class="checkbox__input"
	[class.checkbox__input--invalid]="invalid"
	[id]="checkboxId"
	[checked]="value"
	(change)="handleOnChange($event)"
/>
<label [for]="checkboxId" class="checkbox__label" [class.checkbox__label--invalid]="invalid">
	<ng-content></ng-content>
</label>
